import { motion } from 'framer-motion'

type Props = {
  children: React.ReactNode
}

const TrailAnimation = ({ children }: Props) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={{
        hidden: {
          opacity: 0,
          y: 100,
        },
        show: {
          opacity: 1,
          y: 0,
          transition: { ease: 'easeInOut' },
        },
      }}
    >
      {children}
    </motion.div>
  )
}

export default TrailAnimation
